/*
 * @Author: 朱占为
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-07-16 13:15:04
 * @LastEditTime: 2022-02-09 11:31:48
 */

import { createApp } from 'vue';

import injectRouter from 'src/routes';
import injectState from 'src/store';
import api from './config/api.config';
import * as common from './config/constant.config';
import * as re from './config/re.config';
import App from './index.vue';
import moment from 'moment';

import { Locale } from 'vant';
import enUS from 'src/locale/lang/en-US';

import injectUI from 'utils/injectUi.js'; // ui组件
import injectLodash from 'utils/injectLodash';
import { post,get} from "utils/request.js"
import VueClipboard from 'vue-clipboard3'
import { PromoCodeServiceFunction } from 'model/common.js';
const _PromoCode = PromoCodeServiceFunction()

import components from "components"

import w_area from './model/whatsapp_code';
import * as error from './utils/_error'

/** **************全局css管理 */
import 'assets/css/reset.css';
import 'assets/css/var.scss';
import 'assets/css/icon.css';
import 'assets/css/public.scss';
import 'assets/css/vant.reset.scss';
import 'vxe-table/lib/style.css'

import vhCheck from "vh-check"; //移动端浏览器100vh高度不一致

vhCheck()
/** **********配置全局組件 */
const app = createApp(App);

// 注入全局組件
components(app)

// 注入ui
injectUI(app);

// 注入路由
const router = injectRouter(app);
Locale.use('en-US', enUS);
// 注入store 状态管理
injectState(app);

//按需注入lodash
injectLodash(app)

// 将api 注入全局
app.provide('$get', get);
app.provide('$post', post);
app.provide('$common', common);
app.provide('$moment', moment);
app.provide('_w_area', w_area);
app.provide('error', error)
//注入正则
app.provide('$re', re);
app.config.globalProperties.$re = re;
//注入接口
app.provide('$url', api);

//注入全局属性
app.provide('_PromoCode', _PromoCode)

app.config.globalProperties.$url = api;

app.config.globalProperties.$moment = moment;
app.config.globalProperties.$common = common;


//捕捉全局错误
// app.config.errorHandler =function (error,vm){
//   console.log("==xxxxxxx",error)
//   console.log("==vm",vm)
// }

//注入复制粘贴功能插件
app.provide('$VueClipboard', VueClipboard);


router.isReady().then(() => app.mount('#app'));
